export function mergeObjectToSearchParams(
  searchParams: URLSearchParams,
  setSearchParams: (
    params: URLSearchParams,
    options?: { replace?: boolean }
  ) => void,
  entries: Array<[string, string | undefined]>
) {
  for (const entrie of entries) {
    if (entrie[1] === '' || entrie[1] === undefined) {
      searchParams.delete(entrie[0])
    } else {
      searchParams.set(entrie[0], entrie[1])
    }
  }
  setSearchParams(searchParams, { replace: true })
}
